declare global {
    interface Window {
        execScript: (s: string) => void;
    }
}

export class JSEvaluatorJs {
    static JSPLACE_ATTR_NAME = "jsplace";

    static findNearestPlace(from: HTMLElement, depth: number): (string|null) {
        while (from !== null && depth > 0) {
            const jsplace = from.getAttribute(JSEvaluatorJs.JSPLACE_ATTR_NAME);
            if (jsplace) {
                return jsplace;
            }
            from = from.parentElement!;
            depth--;
        }
        return null;
    }

    static evalScript(text: string) {
        text.replace(/(^[^<]*<!--)|(-->[^>]*$)/g, "");
        if (!text) {
            // execScript throws an exception if it's argument is empty string
            return;
        }
        if (window.execScript) {
            // для IE
            window.execScript(text);
        } else if (window.eval) {
            // для мозилы
            window.eval(text);
        } else {
            eval(text);
        }
    }

    findAndEvalScripts(element: HTMLElement) {
        const nodeList = element.getElementsByTagName("script");
        if (!nodeList.length) {
            return;
        }

        // копируем потому что список мутируется при изменении DOM
        const scripts = Array.from<HTMLScriptElement>(nodeList);

        scripts.forEach(item => {
            const src = item.getAttribute("src");
            if (src !== null && src.trim()) {
                const parent = item.parentNode!;
                parent.removeChild(item);

                const scrElem = document.createElement("script");
                scrElem.src = src;
                scrElem.type = "text/javascript";

                const onloadScript = item.getAttribute("onload");
                if (onloadScript !== null) {
                    this.addOnloadScript(scrElem, onloadScript);
                }

                parent.appendChild(scrElem);
            } else {
                const text = item.innerHTML;
                this.evalInlineJS(item, text);
            }
        });
    }

    evalInlineJS(context: HTMLScriptElement, script: string) {
        if (script) {
            try {
                JSEvaluatorJs.evalScript(script);
            } catch (ex) {
                this.logError(context, ex as Error);
            }
        }
    }

    logError(script: HTMLScriptElement, ex: Error) {};

    addOnloadScript(scrEl: HTMLScriptElement, scrTxt: string) {
        scrEl.onload = () => {
            this.evalInlineJS(scrEl, scrTxt);
        };
    }
}
